/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QaEquipmentSubCategory = {
    Phantom: 'Phantom',
    Interface: 'Interface',
    WaterTank: 'WaterTank',
    Accessory: 'Accessory',
    Electrometer: 'Electrometer',
    SingleDetector: 'SingleDetector',
    ArrayDetector: 'ArrayDetector',
    OtherDetector: 'OtherDetector',
    DetectorHolder: 'DetectorHolder',
    OtherDosimetryQaEquipment: 'OtherDosimetryQaEquipment'
} as const;
export type QaEquipmentSubCategory = typeof QaEquipmentSubCategory[keyof typeof QaEquipmentSubCategory];


export function QaEquipmentSubCategoryFromJSON(json: any): QaEquipmentSubCategory {
    return QaEquipmentSubCategoryFromJSONTyped(json, false);
}

export function QaEquipmentSubCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentSubCategory {
    return json as QaEquipmentSubCategory;
}

export function QaEquipmentSubCategoryToJSON(value?: QaEquipmentSubCategory | null): any {
    return value as any;
}

/**
 * Check if a given object implements the QaEquipmentSubCategory interface.
 */
 export function instanceOfQaEquipmentSubCategory(value: any): value is QaEquipmentSubCategory {
    return Object.values(QaEquipmentSubCategory).includes(value)
}

